module.exports = __webpack_public_path__ + "img/ellipse.d64aa29f.svg";